var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './sports-header.css';
import { useEffect, useRef, useState } from 'react';
import { eventDetailSubject, sportsbookFilter, sportsSummery, sportsSummerySubject, } from "../../store/sportsbook.store";
import { setFilterCompetitions } from "../../services/sportsbook.services";
import { useForceUpdate } from "../../lib/misc.functions";
import { useNavigate, useParams } from "react-router-dom";
import { getFromLanguageFile, isMobileView } from "../../app";
import { useTranslation } from "react-i18next";
import { member } from "../../store/login.store";
var VISIBLE_COUNT = 5;
function buildDateTabs() {
    var tabs = [{ label: 'All', value: 'all' }];
    var today = new Date();
    for (var i = 0; i < 8; i++) {
        var d = new Date(today);
        d.setDate(today.getDate() + i);
        var value = d.toISOString().substring(0, 10);
        var label = void 0;
        if (i === 0)
            label = 'Today';
        else if (i === 1)
            label = 'Tomorrow';
        else
            label = "".concat(String(d.getDate()).padStart(2, '0'), "/").concat(String(d.getMonth() + 1).padStart(2, '0'));
        tabs.push({ label: label, value: value });
    }
    return tabs;
}
export default function SportsHeader(props) {
    var _a;
    var forceUpdate = useForceUpdate();
    var navigate = useNavigate();
    var params = useParams();
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var base = '/' + i18n.resolvedLanguage;
    var scrollRef = useRef(null);
    var _c = useState(false), canScrollLeft = _c[0], setCanScrollLeft = _c[1];
    var _d = useState(false), canScrollRight = _d[0], setCanScrollRight = _d[1];
    var _e = useState('all'), selectedDate = _e[0], setSelectedDate = _e[1];
    var _f = useState(null), currentEvent = _f[0], setCurrentEvent = _f[1];
    useEffect(function () {
        if (sportsSummery.length > 0)
            forceUpdate();
        var sub = sportsSummerySubject.subscribe(function () {
            forceUpdate();
            setTimeout(updateScrollState, 50);
        });
        return function () { return sub.unsubscribe(); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        var sub = eventDetailSubject.subscribe(function (event) {
            if (event && event !== false && event !== 'toggle') {
                setCurrentEvent(event);
            }
            else {
                setCurrentEvent(null);
            }
        });
        return function () { return sub.unsubscribe(); };
    }, []);
    useEffect(function () {
        updateScrollState();
        window.addEventListener('resize', updateScrollState);
        return function () {
            window.removeEventListener('resize', updateScrollState);
            sportsbookFilter.filterDays = [];
        };
    }, []);
    var updateScrollState = function () {
        var el = scrollRef.current;
        if (!el)
            return;
        setCanScrollLeft(el.scrollLeft > 0);
        setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };
    var scrollSports = function (direction) {
        var el = scrollRef.current;
        if (!el || el.children.length === 0)
            return;
        var itemW = el.children[0].offsetWidth;
        var offset = direction === 'right' ? itemW * VISIBLE_COUNT : -(itemW * VISIBLE_COUNT);
        el.scrollTo({ left: el.scrollLeft + offset, behavior: 'smooth' });
    };
    var handleSportClick = function (sport) {
        setFilterCompetitions('clear');
        sportsbookFilter.filterKeyword = '';
        sportsbookFilter.filterFavorite = false;
        var current = params.eventType || 'tumu';
        var prematch = sport.count - sport.liveEventCount;
        var target = current;
        if (current !== 'canli' && prematch === 0 && sport.liveEventCount > 0) {
            target = 'canli';
        }
        else if (current === 'canli' && sport.liveEventCount === 0 && prematch > 0) {
            target = 'tumu';
        }
        navigate(base + '/sports/' + sport.sportSlug + '/' + target);
    };
    var handleDateClick = function (value) {
        setSelectedDate(value);
        sportsbookFilter.filterDays = value === 'all' ? [] : [value];
        if (props.onFilterChange)
            props.onFilterChange();
    };
    var handleFavorites = function () {
        sportsbookFilter.filterFavorite = !sportsbookFilter.filterFavorite;
        if (props.onFilterChange)
            props.onFilterChange();
        forceUpdate();
    };
    var handleMyBets = function () {
        navigate(base + '/hesabim/bets');
    };
    var sports = sportsSummery
        .filter(function (s) { return Number(s.eventType) !== 2; })
        .map(function (s) {
        var _a, _b, _c, _d, _e, _f;
        return ({
            sportSlug: (_a = s.sportSlug) !== null && _a !== void 0 ? _a : s.sS,
            sportNameId: (_b = s.sportNameId) !== null && _b !== void 0 ? _b : null,
            fallbackName: (_d = (_c = s.sportName) !== null && _c !== void 0 ? _c : s.sN) !== null && _d !== void 0 ? _d : '',
            count: (_e = s.count) !== null && _e !== void 0 ? _e : 0,
            liveEventCount: (_f = s.liveEventCount) !== null && _f !== void 0 ? _f : 0,
        });
    });
    var needsNav = sports.length > VISIBLE_COUNT;
    var currentSport = params.sportSlug === 'tumu' ? (_a = sports[0]) === null || _a === void 0 ? void 0 : _a.sportSlug : params.sportSlug;
    var isLive = params.eventType === 'canli';
    var dateTabs = buildDateTabs();
    if (params.competitionId && isMobileView) {
        return _jsx(_Fragment, {}, void 0);
    }
    if (params.eventId && !isMobileView) {
        var countryName = currentEvent
            ? (getFromLanguageFile(currentEvent.cGNId) || currentEvent.cGN)
            : '';
        var competitionName = currentEvent
            ? (getFromLanguageFile(currentEvent.cNId) || currentEvent.cN)
            : '';
        var score = (currentEvent === null || currentEvent === void 0 ? void 0 : currentEvent.cur) || null;
        return (_jsxs("div", __assign({ className: "sh-container" }, { children: [_jsxs("div", __assign({ className: "sh-breadcrumb" }, { children: [_jsx("button", __assign({ className: "sh-back-btn", onClick: function () { return navigate(-1); } }, { children: _jsx("i", { className: "bc-i-small-arrow-left" }, void 0) }), void 0), _jsx("span", __assign({ className: "sh-bc-country" }, { children: countryName }), void 0), _jsx("span", __assign({ className: "sh-bc-sep" }, { children: "/" }), void 0), _jsx("span", __assign({ className: "sh-bc-league" }, { children: competitionName }), void 0), _jsx("i", { className: "bc-i-small-arrow-right sh-bc-fwd" }, void 0)] }), void 0), _jsxs("div", __assign({ className: "sh-actions" }, { children: [_jsxs("button", __assign({ className: "sh-action-btn".concat(sportsbookFilter.filterFavorite ? ' sh-action-active' : ''), onClick: handleFavorites }, { children: [_jsx("i", { className: "bc-i-favorite" }, void 0), _jsx("span", { children: t('header.nav12') }, void 0)] }), void 0), _jsxs("button", __assign({ className: "sh-action-btn", onClick: handleMyBets }, { children: [_jsx("i", { className: "bc-i-betslip" }, void 0), _jsx("span", { children: member.is_kiosk ? t('header.nav14') : t('header.nav13') }, void 0)] }), void 0)] }), void 0)] }), void 0));
    }
    return (_jsxs("div", __assign({ className: "sh-container" }, { children: [_jsxs("div", __assign({ className: "sh-sports-wrapper" }, { children: [!isMobileView &&
                        _jsx("button", __assign({ className: "sh-nav-btn sh-nav-left".concat(!canScrollLeft ? ' sh-nav-disabled' : ''), onClick: function () { return scrollSports('left'); }, disabled: !canScrollLeft }, { children: _jsx("i", { className: "bc-i-small-arrow-left" }, void 0) }), void 0), _jsx("div", __assign({ className: "sh-sports-track", ref: scrollRef, onScroll: updateScrollState, style: { maxWidth: "calc(".concat(VISIBLE_COUNT, " * var(--sh-item-w))") } }, { children: sports.map(function (item) { return (_jsxs("div", __assign({ className: "sh-sport-item".concat(item.sportSlug === currentSport ? ' sh-active' : ''), onClick: function () { return handleSportClick(item); } }, { children: [_jsx("img", { width: 28, height: 28, src: '/assets/images/sports/' + item.sportSlug.charAt(0).toUpperCase() + item.sportSlug.slice(1) + '.webp', alt: item.sportSlug }, void 0), _jsx("span", __assign({ className: "sh-sport-label" }, { children: getFromLanguageFile(item.sportNameId) || item.fallbackName }), void 0)] }), item.sportSlug)); }) }), currentSport), !isMobileView &&
                        _jsx("button", __assign({ className: "sh-nav-btn sh-nav-right".concat(!canScrollRight ? ' sh-nav-disabled' : ''), onClick: function () { return scrollSports('right'); }, disabled: !canScrollRight }, { children: _jsx("i", { className: "bc-i-small-arrow-right" }, void 0) }), void 0)] }), void 0), !isMobileView &&
                _jsx("div", __assign({ className: "sh-date-section" }, { children: dateTabs.map(function (tab) { return (_jsx("div", __assign({ className: "sh-date-item".concat(selectedDate === tab.value ? ' sh-active' : ''), onClick: function () { return handleDateClick(tab.value); } }, { children: t("".concat(/\d/.test(tab.label) ? '' : 'general.').concat(tab.label.toLowerCase())) }), tab.value)); }) }), void 0), !isMobileView &&
                _jsxs("div", __assign({ className: "sh-actions" }, { children: [_jsxs("button", __assign({ className: "sh-action-btn".concat(sportsbookFilter.filterFavorite ? ' sh-action-active' : ''), onClick: handleFavorites, title: "Favoriler" }, { children: [_jsx("i", { className: "bc-i-favorite" }, void 0), _jsx("span", { children: t('header.nav12') }, void 0)] }), void 0), _jsxs("button", __assign({ className: "sh-action-btn", onClick: handleMyBets, title: "Bahislerim" }, { children: [_jsx("i", { className: "bc-i-betslip" }, void 0), _jsx("span", { children: member.is_kiosk ? t('header.nav14') : t('header.nav13') }, void 0)] }), void 0)] }), void 0)] }), void 0));
}
